import { useState, useEffect } from "react";
import { IoMdInformationCircle } from "react-icons/io";
import { Info } from "lucide-react";
import "../dashboardstyle.css";
import Companysettings from "./setting";

export default function CompanyDashboard() {
  interface JobConfig {
    id: number;
    job_title: string;
    job_description: string;
    extra_info: string;
    min_score_auto_reject: number;
    min_score_auto_invite: number;
    created_at: string;
    manual_review: boolean;
    is_active: boolean;
  }
  interface Application {
    id: number;
    company_id: number;
    job_config_id: number;
    applicant_name: string;
    applicant_email: string;
    score: number;
    status: string;
    ai_reasoning: number;
    created_at: string;
    documents: { type: string; url: string }[];
  }
  const [openGroups, setOpenGroups] = useState<Set<number>>(new Set());
  //state ob eine stelle aktiv ist oder nicht
  //const [active, setActive] = useState(true);
  const [company, setCompany] = useState<any>(null);
  const [jobConfig, setJobConfig] = useState<JobConfig[]>([]);
  const [application, setApplication] = useState<Application[]>([]);
  const [editingConfig, setEditingConfig] = useState<JobConfig | null>(null);

  const [activeTab, setActiveTab] = useState("overview");

  //popup state für delete confirmation, sagt aus es kann eine number sein oder null - Standardwert is aber null
  const [deleteModal, setDeleteModal] = useState<number | null>(null);

  //popup state Config erstellen
  const [showModalConfig, setShowModalConfig] = useState(false);
  const [jobForm, setJobForm] = useState({
    job_title: "",
    job_description: "",
    job_extra_data: "",
    min_score_auto_reject: "" as any,
    min_score_auto_invite: "" as any,
    manual_review: false,
  });
  const openEdit = (config: JobConfig) => {
    setJobForm({
      job_title: config.job_title,
      job_description: config.job_description,
      job_extra_data: config.extra_info ?? "",
      min_score_auto_reject: config.min_score_auto_reject,
      min_score_auto_invite: config.min_score_auto_invite,
      manual_review: config.manual_review ?? false,
    });
    setEditingConfig(config);
    setShowModalConfig(true);
  };
  const loadCompany = async (company_id: number) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/companies/dashboard/${company_id}`,
    );
    const data = await res.json();
    setCompany(data.company);
  };

  const loadAllJobConfigs = async (company_id: number) => {
    const result = await fetch(
      `${process.env.REACT_APP_API_URL}/companies/configuarion/${company_id}`,
    );
    const configs = await result.json();
    console.log("Config", configs.config);
    setJobConfig(configs.config ?? []);
  };
  const toggleGroup = (jobId: number) => {
    setOpenGroups((prev) => {
      const next = new Set(prev);
      next.has(jobId) ? next.delete(jobId) : next.add(jobId);
      return next;
    });
  };

  // Bewerbungen gruppieren
  const grouped = jobConfig.map((job) => ({
    job,
    applications: application.filter((a) => a.job_config_id === job.id),
  }));
  const createJobConfig = async () => {
    const token = localStorage.getItem("token");
    const payLoad = JSON.parse(atob(token!.split(".")[1]));

    await fetch(
      `${process.env.REACT_APP_API_URL}/companies/configuarion/${payLoad.company_id}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(jobForm),
      },
    );

    loadAllJobConfigs(payLoad.company_id);
    setShowModalConfig(false);
  };
  //alle bewerbungen laden
  const loadApplications = async () => {
    const token = localStorage.getItem("token");
    const payLoad = JSON.parse(atob(token!.split(".")[1]));

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/companies/load/bewerbungen/${payLoad.company_id}`,
    );
    const data = await response.json();
    console.log(data);
    setApplication(data.applications);
  };
  //hier wird der active wert in der db verändert, isActive übergibt immer das gegenteil da toggleActive nur aufgerufen wird wenn sich iActive verändert
  const toggleActive = async (config: JobConfig) => {
    await fetch(
      `${process.env.REACT_APP_API_URL}/companies/configuarion/${config.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...config, is_active: !config.is_active }),
      },
    );
    loadAllJobConfigs(company.id);
  };

  useEffect(() => {
    if (activeTab === "applications") {
      loadApplications();
    }
  }, [activeTab]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    const payLoad = JSON.parse(atob(token!.split(".")[1]));

    console.log(payLoad);
    loadCompany(payLoad.company_id);
    loadAllJobConfigs(payLoad.company_id);
  }, []);

  //bewerbung manuell löschen & löscht im backend die documents aus dem R2 Cloudflare speicher
  const deleteApplication = async (id: number) => {
    await fetch(`${process.env.REACT_APP_API_URL}/companies/delete/pdf/${id}`, {
      method: "DELETE",
    });
    loadApplications();
  };

  const updateJobConfig = async () => {
    const token = localStorage.getItem("token");
    const payLoad = JSON.parse(atob(token!.split(".")[1]));

    await fetch(
      `${process.env.REACT_APP_API_URL}/companies/configuarion/${editingConfig!.id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(jobForm),
      },
    );

    loadAllJobConfigs(payLoad.company_id);
    setShowModalConfig(false);
    setEditingConfig(null);
  };
  const tabs = [
    { id: "overview", label: "Übersicht" },
    { id: "jobs", label: "Jobs Konfiguration" },
    { id: "applications", label: "Bewerbungen" },
    { id: "settings", label: "Einstellungen" },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0a0f",
        fontFamily: "'DM Sans', sans-serif",
        color: "#f0f0f0",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "32px 48px 0",
          borderBottom: "1px solid rgba(255,255,255,0.07)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          <h1
            style={{
              fontFamily: "'Syne', sans-serif",
              fontSize: "1.8rem",
              fontWeight: 800,
              letterSpacing: "-0.03em",
              margin: 0,
            }}
          >
            {company && <span>{company.name}</span>}
            {!company && (
              <span style={{ color: "rgba(255,255,255,0.2)" }}>Laden...</span>
            )}
          </h1>

          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              background: "rgba(200,241,53,0.1)",
              border: "1px solid rgba(200,241,53,0.2)",
              color: "#c8f135",
              padding: "5px 14px",
              borderRadius: "100px",
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase" as const,
            }}
          >
            {company?.subdomain}
          </div>
        </div>

        {/* Tabs */}
        <div style={{ display: "flex", gap: "4px" }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: "40px 48px" }}>
        {activeTab === "overview" && (
          <div>
            <p style={{ color: "rgba(255,255,255,0.4)" }}>
              Übersicht kommt hier
            </p>
          </div>
        )}
        {activeTab === "jobs" && (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "32px",
              }}
            >
              <h2 style={{ fontFamily: "'Syne', sans-serif", margin: 0 }}>
                Jobs
              </h2>
              <button
                onClick={() => setShowModalConfig(true)}
                className="btn-add"
              >
                + Neue Konfiguration
              </button>
            </div>

            {jobConfig.length === 0 ? (
              <p style={{ color: "rgba(255,255,255,0.4)" }}>
                Keine Jobs konfiguriert
              </p>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {jobConfig.map((config) => (
                  <div
                    key={config.id}
                    style={{
                      background: "#14141e",
                      border: "1px solid rgba(255,255,255,0.07)",
                      borderRadius: "12px",
                      padding: "20px 24px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <p
                        style={{ margin: 0, fontWeight: 600, fontSize: "1rem" }}
                      >
                        {config.job_title}
                      </p>
                      <p
                        style={{
                          margin: "4px 0 0",
                          color: "rgba(255,255,255,0.4)",
                          fontSize: "0.85rem",
                        }}
                      >
                        {config.job_description}
                      </p>
                      <p
                        style={{
                          margin: "4px 0 0",
                          color: "rgba(255,255,255,0.3)",
                          fontSize: "0.8rem",
                        }}
                      >
                        Einladen ab {config.min_score_auto_invite} · Ablehnen
                        unter {config.min_score_auto_reject}
                      </p>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                      }}
                    >
                      <span
                        style={{
                          background: config.is_active
                            ? "rgba(200,241,53,0.1)"
                            : "rgba(255,255,255,0.05)",
                          color: config.is_active
                            ? "#c8f135"
                            : "rgba(255,255,255,0.3)",
                          padding: "4px 12px",
                          borderRadius: "100px",
                          fontSize: "0.75rem",
                          fontWeight: 700,
                          textAlign: "center",
                        }}
                      >
                        {config.is_active ? "Aktiv" : "Inaktiv"}
                      </span>
                      <label className="toggle">
                        <input
                          type="checkbox"
                          checked={config.is_active}
                          onChange={(e) => {
                            toggleActive(config);
                          }}
                        />
                        <span className="toggle-slider" />
                      </label>
                      <button
                        style={{
                          background: "rgba(255,255,255,0.05)",
                          color: "rgba(255,255,255,0.6)",
                          padding: "4px 12px",
                          borderRadius: "100px",
                          fontSize: "0.75rem",
                          fontWeight: 700,
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          openEdit(config);
                        }}
                      >
                        Bearbeiten
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {activeTab === "applications" && (
          <div>
            {grouped.map(({ job, applications: jobApplications }) => (
              <div key={job.id} style={{ marginBottom: 24 }}>
                {/* Header klappbar */}
                <div
                  onClick={() => toggleGroup(job.id)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(255,255,255,0.07)",
                    borderRadius: 10,
                    cursor: "pointer",
                    marginBottom: openGroups.has(job.id) ? 12 : 0,
                    transition: "all 0.2s",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "'Syne'",
                      fontWeight: 700,
                      fontSize: "0.95rem",
                    }}
                  >
                    {job.job_title}
                  </span>
                  <div
                    style={{ display: "flex", gap: 12, alignItems: "center" }}
                  >
                    <span
                      style={{
                        fontSize: "0.75rem",
                        color: "rgba(255,255,255,0.35)",
                      }}
                    >
                      {jobApplications.length} Bewerbung
                      {jobApplications.length !== 1 ? "en" : ""}
                    </span>
                    <span
                      style={{
                        color: "rgba(255,255,255,0.4)",
                        fontSize: "0.8rem",
                      }}
                    >
                      {openGroups.has(job.id) ? "▲" : "▼"}
                    </span>
                  </div>
                </div>

                {/* Cards */}
                {openGroups.has(job.id) &&
                  (jobApplications.length === 0 ? (
                    <p
                      style={{
                        color: "rgba(255,255,255,0.3)",
                        fontSize: "0.85rem",
                        padding: "12px 16px",
                      }}
                    >
                      Keine Bewerbungen
                    </p>
                  ) : (
                    jobApplications.map((applicant) => (
                      <div key={applicant.id} className="application-card">
                        {/* Zeile 1: Name + Datum */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            marginBottom: 10,
                          }}
                        >
                          <div>
                            <span
                              style={{
                                fontFamily: "'DM Sans'",
                                fontWeight: 600,
                                color: "#f0f0f0",
                                fontSize: "1rem",
                              }}
                            >
                              {applicant.applicant_name}
                            </span>
                            <span
                              style={{
                                display: "block",
                                fontSize: "0.78rem",
                                color: "rgba(255,255,255,0.35)",
                                marginTop: 2,
                              }}
                            >
                              {applicant.applicant_email}
                            </span>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-end",
                              gap: 6,
                            }}
                          >
                            <span
                              style={{
                                fontSize: "0.75rem",
                                color: "rgba(255,255,255,0.25)",
                                fontFamily: "'DM Sans'",
                              }}
                            >
                              {new Date(
                                applicant.created_at,
                              ).toLocaleDateString("de-DE", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </span>
                          </div>
                        </div>

                        {/* Zeile 2: AI Reasoning */}
                        <p
                          style={{
                            fontSize: "0.82rem",
                            color: "rgba(255,255,255,0.45)",
                            margin: "0 0 14px 0",
                            lineHeight: 1.5,
                            fontFamily: "'DM Sans'",
                          }}
                        >
                          {applicant.ai_reasoning}
                        </p>

                        {/* Zeile 3: Status + Score */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ display: "flex", gap: 8 }}>
                            <span
                              style={{
                                fontSize: "0.75rem",
                                fontWeight: 600,
                                letterSpacing: "0.05em",
                                textTransform: "uppercase",
                                color: "rgba(255,255,255,0.3)",
                                fontFamily: "'DM Sans'",
                              }}
                            >
                              {applicant.status}
                            </span>
                            {applicant.documents?.map((doc: any) => (
                              <a
                                key={doc.type}
                                href={doc.url}
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: "#c8f135", fontSize: "0.8rem" }}
                              >
                                📄 {doc.type}
                              </a>
                            ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <span
                              className={`score-badge ${applicant.score >= 70 ? "score-high" : applicant.score >= 40 ? "score-mid" : "score-low"}`}
                            >
                              {applicant.score} / 100
                            </span>
                            <button
                              style={{ color: "red" }}
                              onClick={() => {
                                setDeleteModal(applicant.id);
                              }}
                            >
                              Löschen
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  ))}
              </div>
            ))}

            {deleteModal !== null && (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  background: "rgba(0,0,0,0.6)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 400,
                }}
              >
                <div
                  style={{
                    background: "#14141e",
                    border: "1px solid rgba(255,255,255,0.07)",
                    borderRadius: "16px",
                    padding: "40px",
                    width: "480px",
                    position: "relative", // wichtig!
                  }}
                >
                  <p style={{ color: "white" }}>
                    Sind Sie sicher dass Sie diesen Bewerber löschen wollen?
                  </p>
                  <div style={{ display: "flex", gap: 12 }}>
                    <button onClick={() => setDeleteModal(null)}>
                      Abbrechen
                    </button>
                    <button
                      style={{ color: "red" }}
                      onClick={() => {
                        deleteApplication(deleteModal);
                        setDeleteModal(null);
                      }}
                    >
                      Löschen
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "settings" && <Companysettings />}

        {showModalConfig && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 200,
            }}
          >
            <div
              style={{
                background: "#14141e",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "16px",
                padding: "40px",
                width: "480px",
              }}
            >
              <h3
                style={{
                  fontFamily: "'Syne', sans-serif",
                  margin: "0 0 24px 0",
                }}
              >
                Neuen Konfiguration
              </h3>

              {/* Formular Felder hier */}
              <div>
                <p className={"info-label"}>Job name</p>
                <input
                  className={"modal-input"}
                  value={jobForm.job_title}
                  onChange={(e) =>
                    //... kopiert alle bestehende werte und dann überschreibt sie es mit job_title mit den neuen werten
                    setJobForm({ ...jobForm, job_title: e.target.value })
                  }
                ></input>
              </div>
              {/*
            <div>
              <p className={"info-label"}>Keywords</p>
              <input className={"modal-input"}></input>
            </div>
            */}
              <div>
                <p className={"info-label"}>Stellenausschreibung</p>
                <input
                  className={"modal-input"}
                  value={jobForm.job_description}
                  onChange={(e) =>
                    //... kopiert alle bestehende werte und dann überschreibt sie es mit job_description mit den neuen werten
                    setJobForm({ ...jobForm, job_description: e.target.value })
                  }
                />
              </div>
              <div>
                <p className={"info-label"}>
                  Was die KI noch zusätzlich wissen sollte
                </p>
                <input
                  className={"modal-input"}
                  value={jobForm.job_extra_data}
                  onChange={(e) =>
                    //... kopiert alle bestehende werte und dann überschreibt sie es mit job_description mit den neuen werten
                    setJobForm({ ...jobForm, job_extra_data: e.target.value })
                  }
                />
              </div>

              <div>
                <p className={"info-label"}>Min. Einladen</p>
                <input
                  type="number"
                  min={0}
                  max={100}
                  className="modal-input"
                  placeholder="z.B. 75"
                  value={jobForm.min_score_auto_invite}
                  onChange={(e) =>
                    setJobForm({
                      ...jobForm,
                      min_score_auto_invite:
                        e.target.value === "" ? "" : Number(e.target.value),
                    })
                  }
                />
              </div>
              <div>
                <p className={"info-label"}>Min. Ablehnen</p>
                <input
                  type="number"
                  min={0}
                  max={100}
                  className="modal-input"
                  placeholder="z.B. 40"
                  value={jobForm.min_score_auto_reject}
                  onChange={(e) =>
                    setJobForm({
                      ...jobForm,
                      min_score_auto_reject:
                        e.target.value === "" ? "" : Number(e.target.value),
                    })
                  }
                />
              </div>

              <div>
                <p className="info-label">Manuelle Prüfung</p>
                <label
                  style={{
                    position: "relative",
                    width: 40,
                    height: 22,
                    display: "inline-block",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={jobForm.manual_review}
                    onChange={(e) =>
                      setJobForm({
                        ...jobForm,
                        manual_review: e.target.checked,
                      })
                    }
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: jobForm.manual_review
                        ? "#c8f135"
                        : "rgba(255,255,255,0.1)",
                      borderRadius: 22,
                      cursor: "pointer",
                      transition: "0.2s",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      inset: 0,
                      background: jobForm.manual_review
                        ? "#c8f135"
                        : "rgba(255,255,255,0.1)",
                      borderRadius: 22,
                      cursor: "pointer",
                      transition: "0.2s",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        width: 16,
                        height: 16,
                        left: jobForm.manual_review ? 21 : 3,
                        top: 3,
                        background: "white",
                        borderRadius: "50%",
                        transition: "0.2s",
                      }}
                    />
                  </span>

                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      marginTop: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    {[
                      { range: "0–39", label: "Kaum", color: "#ff5050" },
                      { range: "40–69", label: "Teilweise", color: "#ffb400" },
                      { range: "70–89", label: "Gut", color: "#c8f135" },
                      { range: "90–100", label: "Sehr gut", color: "#c8f135" },
                    ].map((item) => (
                      <div
                        key={item.range}
                        style={{
                          background: "rgba(255,255,255,0.04)",
                          border: "1px solid rgba(255,255,255,0.07)",
                          borderRadius: 8,
                          padding: "4px 10px",
                          fontSize: "0.75rem",
                          color: item.color,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.range} · {item.label}
                      </div>
                    ))}
                  </div>
                </label>
                {jobForm.manual_review && (
                  <p>
                    Manuell prüfen: {jobForm.min_score_auto_reject} –{" "}
                    {jobForm.min_score_auto_invite}
                  </p>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                  marginTop: "24px",
                }}
              >
                <button
                  onClick={() => {
                    loadAllJobConfigs(company.id);
                    setShowModalConfig(false);
                  }}
                >
                  Abbrechen
                </button>
                <button
                  onClick={() =>
                    editingConfig ? updateJobConfig() : createJobConfig()
                  }
                  className="btn-add"
                >
                  {editingConfig ? "Speichern" : "Erstellen"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
